import api from '@/api/base'

export default {
    crew(pin, company, crew, date) {
        return api().get(`/survey/${pin}/${company._id}/crew/${crew._id}/${date}`);
    },
    employee(pin, company, employee, date) {
        return api().get(`/survey/${pin}/${company._id}/employee/${employee._id}/${date}`);
    },
    post(pin, company, employee, date, responses) {
        return api().put(`/survey/${pin}/${company._id}/employee/${employee._id}/${date}`, responses);
    }
}